import { Tool } from '../../types';

export const automationTools: Tool[] = [
  {
    id: 'zapier',
    name: 'Zapier',
    category: 'Automation',
    description: 'Connect your apps and automate workflows without coding',
    pricing: ['free', 'medium'],
    features: ['automation', 'integrations', 'ease-of-use'],
    bestFor: ['small-business', 'freelancer'],
    compatibleWith: ['service-business', 'content-creator'],
    goals: ['automate-tasks', 'streamline-operations'],
    industries: ['technology', 'marketing', 'creative'],
    website: 'https://zapier.com',
    imageUrl: 'https://logo.clearbit.com/zapier.com',
    idealStages: ['launching', 'growing'],
    technicalLevel: ['beginner', 'intermediate'],
    minTeamSize: 'solo'
  },
  {
    id: 'make',
    name: 'Make.com',
    category: 'Automation',
    description: 'Visual automation platform for connecting apps and automating work',
    pricing: ['free', 'medium'],
    features: ['automation', 'integrations', 'scalability'],
    bestFor: ['startup', 'small-business'],
    compatibleWith: ['saas', 'service-business'],
    goals: ['automate-tasks', 'streamline-operations'],
    industries: ['technology', 'marketing'],
    website: 'https://www.make.com',
    imageUrl: 'https://logo.clearbit.com/make.com',
    idealStages: ['growing', 'scaling'],
    technicalLevel: ['intermediate', 'advanced'],
    minTeamSize: 'solo'
  },
  {
    id: 'n8n',
    name: 'n8n',
    category: 'Automation',
    description: 'Open source workflow automation tool',
    pricing: ['free', 'medium'],
    features: ['automation', 'integrations', 'self-hosted'],
    bestFor: ['startup', 'small-business'],
    compatibleWith: ['saas', 'service-business'],
    goals: ['automate-tasks', 'streamline-operations'],
    industries: ['technology'],
    website: 'https://n8n.io',
    imageUrl: 'https://logo.clearbit.com/n8n.io',
    idealStages: ['growing', 'scaling'],
    technicalLevel: ['intermediate', 'advanced'],
    minTeamSize: 'solo'
  }
];